<div class="row">
	<div class="col-lg-10 offset-lg-1 col-12 jmDashTitle">
		<div class="row">
			<div class="col-12 jmNoPaddingCol">
				<div class="jmDashTitleBlock jmPageTitle">NCES School</div>
			</div>
			<div class="col-12">
				<div style="display:table; width:100%;">
					<div *ngIf="!isAnonymous" style="display: table-cell;"><app-navigation-history></app-navigation-history></div>
					<div *ngIf="school!=null" style="display: table-cell;" class="text-lg-end"><app-subscription [name]="school.Name" [source]="'NCES'" [sourceId]="school.NCESSCH"></app-subscription></div>
				</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="status===0" class="d-flex align-items-center justify-content-center w-100 h-100">
	<span class="jmWidgetLoadingIcon40"></span>
</div>

<app-institution-welcome *ngIf="school!=null" ></app-institution-welcome>

<div *ngIf="status===1 && school!=null" style="margin-top:10px; margin-bottom:50px;">
	<gridster [options]="gridsterOptions" class="jmGridster" [appGridsterLazyLoad]="gstItems">
		<gridster-item id="giNCESLogoCover" [item]="gstItemSize.logoCover" class="jmGridsterItem">
			<app-nces-logo-cover *ngIf="gstItems.giNCESLogoCover" [schoolId]="school.NCESSCH" [schoolName]="school.Name" [logoImage]="school.LogoImage" [coverImage]="school.CoverImage" [schoolUrl]="school.Url" [city]="school.City" [state]="school.State" [zipCode]="school.ZipCode" [location]="school.Location"></app-nces-logo-cover>
		</gridster-item>
		<gridster-item id="giProgressAction" [item]="gstItemSize.progressAction" class="jmGridsterItem" style="background: transparent">
			<app-my-progress *ngIf="gstItems.giProgressAction"></app-my-progress>
		</gridster-item>
		<gridster-item id="giRegionalStatistics" [item]="gstItemSize.regionalStatistics" class="jmGridsterItem" style="background-color:unset;">
			<app-bls-regional-statistics [zipCode]="school.ZipCode" [state]="school.State"></app-bls-regional-statistics>
		</gridster-item>
		<gridster-item id="giNCESNearby" [item]="gstItemSize.nearby" class="jmGridsterItem">
			<app-nces-nearby *ngIf="gstItems.giNCESNearby" [schoolId]="schoolId" (hasData)="hasData($event, 'nearby')"></app-nces-nearby>
		</gridster-item>
	</gridster>
</div>
